import React, { useContext } from "react";
import { UserContext } from "../context/UserContext";
import { useMediaQuery } from "@mui/material";

const HomePage: React.FC = () => {
    const { isLoggedIn } = useContext(UserContext);
    const buttonClassName = `px-10 py-3 bg-blue-500 text-white rounded-md shadow-md hover:bg-blue-600 dark:bg-blue-700 dark:hover:bg-blue-800 transition duration-300 text-center`;
    const isMobile = useMediaQuery("(max-width:1100px)"); // Adjusted media query for better transition

    return (
        <div className={`flex flex-col items-center justify-center min-h-screen ${isMobile ? "" : "ml-72"}`}>
            <div className="ml-0 px-6 py-8 max-w-5xl text-center">
                <h1 className="text-5xl font-extrabold">
                    Welcome to <span className="block sm:inline text-blue-600 dark:text-blue-400">Material Logs</span>
                </h1>
                <p className="text-lg mb-10 max-w-3xl mt-6 mx-auto">
                    Efficiently manage your raw materials and keep track of your inventory with our intuitive platform.
                    Easily monitor material levels, organize your stock, and streamline your workflow—whether for small
                    projects or large-scale operations.
                </p>

                {/* Know More button */}
                <div className="flex justify-center py-4">
                    <a
                        href="/instructions"
                        className={`${buttonClassName} w-72`}
                    >
                        Know More
                    </a>
                </div>

                {/* Conditionally render the Login and Sign Up buttons, centered */}
                {!isLoggedIn && (
                    <div className="flex justify-center py-4">
                        <a href="/login" className={`${buttonClassName} w-72`}>
                            Login
                        </a>
                    </div>
                )}
            </div>
        </div>
    );
};

export default HomePage;
